import CreateAmazonIdeaTemplatePage from "../components/amazon-idea-template/create-amazon-idea-template.page";
import UpdateAmazonIdeaTemplatePage from "../components/amazon-idea-template/update-amazon-idea-template.page";
import CreateAmazonIdeaPage from "../components/amazon-idea/create-amazon-idea-page";
import UpdateAmazonIdeaPage from "../components/amazon-idea/update-amazon-idea-page";
import { EditStorePolaris } from "../components/store/EditStorePolaris";
import MainLayout from "../layout/MainLayout";
import AddAmazonAccount from "../pages/seller/AddAmazonAccount";
import Amazon from "../pages/seller/Amazon";
import { OrdersPagePolaris } from "../pages/seller/OrdersPagePolaris";
import { OrdersPagePolaris2 } from '../pages/seller/OrdersPagePolaris2';
import { ProductsPagePolaris } from "../pages/seller/ProductsPagePolaris";
import Stores from "../pages/seller/Stores";
import AmazonIdeaTemplatePage from "../pages/seller/amazon-idea-template.page";
import AmazonIdeaPage from "../pages/seller/amazon-idea.page";
import { TEAM_ROLE, USER_ROLE } from "../variable";

const pathname = "/channel-seller";
export default [
    {
        path: `${pathname}/stores`,
        exact: true,
        component: Stores,
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },
    {
        path: `${pathname}/stores/amazon`,
        exact: true,
        component: Amazon,
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },
    {
        path: `${pathname}/stores/amazon/add`,
        exact: true,
        component: AddAmazonAccount,
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },
    {
        path: `${pathname}/store/edit/:id`,
        exact: true,
        component: EditStorePolaris,
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },

    {
        path: `${pathname}/amazon-ideas`,
        exact: true,
        component: AmazonIdeaPage,
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },

    {
        path: `${pathname}/amazon-ideas/create`,
        exact: true,
        component: CreateAmazonIdeaPage,
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },
    {
        path: `${pathname}/amazon-ideas/:id/update`,
        exact: true,
        component: UpdateAmazonIdeaPage,
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },

    {
        path: `${pathname}/amazon-idea-templates`,
        exact: true,
        component: AmazonIdeaTemplatePage,
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },

    {
        path: `${pathname}/amazon-idea-templates/create`,
        exact: true,
        component: CreateAmazonIdeaTemplatePage,
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },
    {
        path: `${pathname}/amazon-idea-templates/:id/update`,
        exact: true,
        component: UpdateAmazonIdeaTemplatePage,
        layout: MainLayout,
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },
    {
        path: `${pathname}/orders2`,
        exact: true,
        component: OrdersPagePolaris,
        layout: MainLayout,
        title: "Orders",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },
    {
        path: `${pathname}/orders`,
        exact: true,
        component: OrdersPagePolaris2,
        layout: MainLayout,
        title: "Orders",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },
    {
        path: `${pathname}/products`,
        exact: true,
        component: ProductsPagePolaris,
        layout: MainLayout,
        title: "Products",
        roles: [USER_ROLE.Seller],
        teamRole: TEAM_ROLE.ChannelSeller,
    },
];
